<template>
  <div class="c-switch c:row-center-center">
    <div class="c-switch-block" :class="{ checked }"></div>
    <div
      class="c-switch-option unchecked"
      :class="{ active: !checked }"
      @click="throttledOnOptionClick(uncheckedValue)"
    >
      {{ uncheckedText }}
    </div>
    <div
      class="c-switch-option checked"
      :class="{ active: checked }"
      @click="throttledOnOptionClick(checkedValue)"
    >
      {{ checkedText }}
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    value: {
      type: [Boolean, Number, String],
      default: false,
    },
    checkedValue: {
      type: [Boolean, Number, String],
      default: true,
    },
    uncheckedValue: {
      type: [Boolean, Number, String],
      default: false,
    },
    checkedText: {
      type: String,
      default: "是",
    },
    uncheckedText: {
      type: String,
      default: "否",
    },
  },
  computed: {
    checked() {
      return this.value === this.checkedValue;
    },
  },
  created() {
    this.throttledOnOptionClick = throttle(this.onOptionClick, 500);
  },
  methods: {
    onOptionClick(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="less" scoped>
.c-switch {
  position: relative;
  width: max-content;
  height: 25/20rem;
  padding: 2/20rem;
  border-radius: 13/20rem;
  background-color: #1b1b1b;

  .c-switch-block {
    position: absolute;
    width: calc(50% - 0.1rem);
    height: 21/20rem;
    left: 2/20rem;
    border-radius: 12/20rem;
    background-color: #fff;

    transition: left 300ms ease;

    &.checked {
      left: 50%;
    }
  }

  .c-switch-option {
    position: relative;
    height: 21/20rem;
    padding: 5/20rem 8/20rem;

    line-height: 11/20rem;
    font-weight: 400;
    font-size: 10/20rem;
    letter-spacing: 0;
    color: #fff;

    transition: color 300ms ease;

    &.active {
      color: #1b1b1b;
    }
  }
}
</style>
